import { ptLogs } from '@com/utils/report-logs/pt'
import { ActionLogData, LogsActions } from '@com/utils/report-logs'

let action: LogsActions | null = null

const actionTimeStore = new Map<string, number>()

const actionStore = new Map<string, LogsActions>()

const ptTracker = {
  startTime: 0,
  startEvent: function (options: ActionLogData): void {
    const eventOptions = options || {}
    this.startTime = Date.now()
    action = ptLogs.createAction({ scene: 'pt' })
    action.log({
      e: 'init',
      et: 's',
      ...eventOptions,
    })
  },
  stopEvent: function (options: ActionLogData): void {
    if (action) {
      const eventOptions = options || {}
      eventOptions.status =
        typeof eventOptions.status === 'undefined' ? 2 : eventOptions.status
      action.log({
        e: 'init',
        et: 'e',
        d: Date.now() - this.startTime,
        ...eventOptions,
      })
      action = null
    }
  },
  startEventById: function (options: ActionLogData, id: string): void {
    const eventOptions = options || {}
    actionTimeStore.set(id, Date.now())
    const action = ptLogs.createAction({ scene: 'pt' })
    action.log({
      e: 'init',
      et: 's',
      ...eventOptions,
    })
    actionStore.set(id, action)
  },
  stopEventById: function (options: ActionLogData, id: string): void {
    if (actionStore.has(id)) {
      const eventOptions = options || {}
      eventOptions.status =
        typeof eventOptions.status === 'undefined' ? 2 : eventOptions.status
      const action = actionStore.get(id) as LogsActions
      action.log({
        e: 'init',
        et: 'e',
        d: Date.now() - actionTimeStore.get(id)!,
        ...eventOptions,
      })
      actionStore.delete(id)
    }
  },
}

export default ptTracker
